import Api from "@/services/api.service";

export default {
  register(object) {
    return Api().post("register", object);
  },
  login(credentials) {
    return Api().post("login", credentials);
  },
  getRoleName() {
    return Api().get("role/getName");
  },
  getCurrentRegisterStep(object) {
    return Api().post("getCurrentRegisterStep", object);
  },
  changePassword(credentials) {
    return Api().patch("change-password", credentials);
  },
  forgotPassword(credentials) {
    return Api().post("forgot-password", credentials);
  },
  resetPassword(credentials) {
    return Api().post("reset-password", credentials);
  },
  verifyEmail(credentials) {
    return Api().post("verify-email", credentials);
  },
  logout() {
    return Api().post("logout");
  },
  delete(userId, password) {
    return Api().delete(`user/${userId}`, {
      password
    });
  },
  getSpeciality() {
    return Api().get("speciality");
  },
  getClinics() {
    return Api().get("clinic/public/clinicList");
  }
};
